import { environment } from 'src/environments/environment';

export class CommonFunctionService {
  addFilterToEndpoint(endpoint: string, filter?: {}) {
    !!filter &&
      Object.keys(filter).map((key) => {
        endpoint += `/${key}/${filter[key]}`;
      });
    if (
      !filter ||
      Object.keys(filter).length === 0 ||
      !filter.hasOwnProperty('search-string')
    ) {
      endpoint += `/search-string/null`;
    }
    endpoint +=
      !endpoint.includes('page-index') && `/page-size/24/page-index/0`;

    return endpoint;
  }

  addFilterToEndpointWithoutPagination(endpoint: string, filter?: {}) {
    !!filter &&
      Object.keys(filter).map((key) => {
        endpoint += `/${key}/${filter[key]}`;
      });
    if (
      !filter ||
      Object.keys(filter).length === 0 ||
      !filter.hasOwnProperty('search-string')
    ) {
      endpoint += `/search-string/null`;
    }

    return endpoint;
  }

  findApiUrl(role) {
    let url = '';
    switch (role) {
      case 'listing-admin':
        url = environment.listingAdminUrl;
        break;
      case 'user-admin':
        url = environment.userAdminUrl;
        break;
      case 'event-admin':
        url = environment.eventAdminUrl;
        break;
      case 'organisation-admin':
        url = environment.organisationAdminUrl;
        break;
      case 'retired-user-admin':
        url = environment.retiredUserAdminUrl;
        break;
      case 'finance-admin':
        url = environment.financeAdminUrl;
        break;
      case 'admin':
        url = environment.adminUrl;
        break;
      case 'notification-admin':
        url = environment.notificationAdminUrl;
        break;
      case 'branch-admin':
        url = environment.branchAdminUrl;
        break;
      default:
        url = environment.apiUrl;
    }
    return url;
  }
}
